import { motion } from 'framer-motion';
import Link from 'next/link';
import { featurePages } from '@/data/featurePages';

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-gray-50 relative">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIzIiBmaWxsPSIjYjM4ZjZhIiBvcGFjaXR5PSIwLjEiLz4KPC9zdmc+Cg==')]" />
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <motion.h2 
            className="text-4xl md:text-5xl font-display font-bold text-primary-900 mb-4 tracking-tight"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Building Tomorrow’s Balinese Legacy
          </motion.h2>
          <motion.p 
            className="text-lg text-neutral-700 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            We’re a new-generation cattery pairing science-backed wellness, modern storytelling, and concierge care to raise luminous Balinese companions for visionary families.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {featurePages.map((feature, index) => (
            <motion.div
              key={feature.href}
              className={`group relative overflow-hidden rounded-3xl border border-white/60 bg-gradient-to-br ${feature.accent} p-8 shadow-[0_18px_45px_rgba(120,120,120,0.15)] transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_26px_60px_rgba(120,120,120,0.2)]`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
            >
              <div className="space-y-4">
                <div className="inline-flex items-center gap-3 rounded-full bg-white/70 px-4 py-2 text-xs uppercase tracking-[0.35em] text-neutral-500">
                  <span className="text-lg">{feature.icon}</span>
                  <span>{feature.title}</span>
                </div>
                <p className="text-neutral-700 leading-relaxed min-h-[96px]">
                  {feature.summary}
                </p>
                <Link
                  href={feature.href}
                  className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600 hover:text-accent-700 transition-colors"
                >
                  Learn more
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
